var __TEMP__ = require('./_arrayFilter.js');var arrayFilter = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseFilter.js');var baseFilter = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseIteratee.js');var baseIteratee = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isArray.js');var isArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./negate.js');var negate = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate, 3)));
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = reject;
